export default Object.freeze({
    NOT_LOADED:   Symbol("NOT_LOADED"),
    LOADING:  Symbol("LOADING"),
    ERROR: Symbol("ERROR"),
    DONE: Symbol("DONE"),
});